import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthLoginService {
  baseURL = environment.apiURL;
  private interceptBypassedHttp: HttpClient;

  constructor(
    private http: HttpClient,
    private stateService: StatePersistService,
    private handler: HttpBackend // 👈 Injected low-level handler to bypass interceptors
  ) { 
    // This client goes straight to the backend without hitting your HTTP_INTERCEPTORS array
    this.interceptBypassedHttp = new HttpClient(handler);
  }

  authToken(is_type_refresh:boolean=false):Observable<any> {
    const body = new FormData();
    const encrypted_username = this.createHashedPassword(environment.username);
    const encrypted_password = this.createHashedPassword(environment.password);
    body.append('username', encrypted_username);
    body.append('password', encrypted_password);
    body.append('client_id', environment.client_id);
    body.append('client_secret', environment.client_secret);
    const url = this.baseURL + 'api/v3/o/token/'
    if(is_type_refresh){
      const token:any = this.stateService.getLocalStorage('user_access_token');
      const user_details:any = this.stateService.getLocalStorage('currentUser');
     
      body.append('refresh_token',user_details?.tokens?.refresh_token ? user_details?.tokens?.refresh_token : token?.refresh_token);
      body.append('grant_type','refresh_token');

    }else{
      body.append('grant_type',environment.grant_type);
    }
    // FIXED: Changed from this.http to this.interceptBypassedHttp
    return this.interceptBypassedHttp.post<any>(url, body);
  }

  signIn(obj: any):Observable<any> {
    return this.http.post<any>(`${this.baseURL}api/v3/accounts/signin/`, obj);
  }

  signInV2(obj: any):Observable<any> {
    return this.http.post<any>(`${this.baseURL}api/v3/accounts/signin/`, obj);
  }

  signOut():Observable<any> {
    return this.http.put<any>(`${this.baseURL}web/v3/accounts/signout/`, {});
  }

  forgetPassword(obj: any):Observable<any> {
    return this.http.post<any>(`${this.baseURL}api/v3/accounts/forgotpassword/`, obj);
  }

  userExistOrNot(obj: any):Observable<any> {
    return this.http.post<any>(`${this.baseURL}web/v3/accounts/email-exist-or-not/`, obj);
  }

  retailerSignup (obj: any):Observable<any> {
    return this.http.post<any>(`${this.baseURL}rest/V1/retailerSignup/`, obj);
  }

  refreshAccessToken():Observable<any> {
    const currentUser = this.stateService.getLocalStorage('currentUser');
    const data = { refresh_token: currentUser.refresh_token, access_token: currentUser.access_token };
    return this.http.post<any>(`${this.baseURL}accounts/token/`, data);
  }

  getAuthRefToken():Observable<any>{
    // FIXED: Changed from this.http to this.interceptBypassedHttp
    return this.interceptBypassedHttp.get(`${this.baseURL}api/v3/accounts/refresh-token/`);
  }

  createHashedPassword(password:string):string { 
    let CryptoJS = require("crypto-js");

    let key = CryptoJS.enc.Utf8.parse(environment?.hashedSecretKey);

    let iv = CryptoJS.enc.Utf8.parse(environment?.hashedIV);

    const ciphertext = CryptoJS.AES.encrypt(password, key, {
      iv: iv,
      mode: CryptoJS.mode.CTR,
      padding:CryptoJS.pad.Pkcs7
    }).toString(); 
    return ciphertext;
  }
}
